export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false // SSR safe
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}
